<template>
<div class="chapter">
<div class="inner_page">
<p class="tx"><br/><br/><br/><br/><br/><br/></p>
<p class="author"><i>To my children,</i></p>
<p class="author"><i>Jeneen, George and Faram,</i></p>
<p class="author"><i>I dedicate this work.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// author.vue?27eb8b13